import React from 'react';
import { TFileExtension } from 'types';
import { useBlobDownload } from 'hooks/useBlobDownload';
import Text from 'components/Text/Text';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import classNames from 'classnames';
import style from './UploaderAndDownloader.module.scss';

interface IBlobDownloader {
	filePath: Nullable<string>;
	fileExtension: TFileExtension;
	fileName: string;
	label: string;
	buttonClassName?: string;
	isShowFileName?: boolean;
	width?: number;
}

const BlobDownloader: React.FC<IBlobDownloader> = ({
	filePath,
	fileExtension,
	fileName,
	label,
	buttonClassName,
	isShowFileName = true,
	width = 350,
}) => {
	const blobDownload = useBlobDownload({ filePath, fileExtension, fileName });
	const loaderClasses = classNames(style.loader, { [style.disabled]: !filePath }, buttonClassName);

	return (
		<div className={style.container} data-test="BlobDownloader">
			<div style={{ width: `${width}px` }} className={loaderClasses} onClick={blobDownload}>
				<div className={style.label}>
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#downloadArrow`} />
					</svg>
					<Text translationNameSpace="form" translationKey={label} asFragment={true} />
				</div>
			</div>
			{filePath && isShowFileName && <div className={style.fileName}>{`${fileName}.${fileExtension}`}</div>}
		</div>
	);
};

export default React.memo(BlobDownloader);
